import axiosInstance from "../api/authAPI";
import { FetchRoleParams, RoleApiResponse } from "../types/roleTypes";
interface RoleDropDown {
  id: number; // use `key` from API as `id` here
  name: string;
}
//Role List
// export const fetchRoleList = async (): Promise<RoleApiResponse> => {
//   try {
//     const response = await axiosInstance.get("/roles");
//     return response.data;
//   } catch (error: any) {
//     throw error.response?.data || { message: "Failed to fetch roles" };
//   }
// };
export const fetchRoleList = async (
  params: FetchRoleParams
): Promise<RoleApiResponse> => {
  try {
    const response = await axiosInstance.get("/roles", { params });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Failed to fetch roles" };
  }
};
// Create Role
export const createRole = async (role: {
  role_name: string;
  display_name: string;
  permission_ids: number[];
}): Promise<RoleApiResponse> => {
  try {
    const formData = new FormData();
    formData.append("role_name", role.role_name);
    formData.append("display_name", role.display_name);
    role.permission_ids.forEach((id) =>
      formData.append("permission_ids[]", id.toString())
    );

    const response = await axiosInstance.post("/roles", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Role creation failed";
  }
};

// Role Delete
export const deleteRole = async (id: number): Promise<RoleApiResponse> => {
  try {
    const response = await axiosInstance.delete(`/roles/${id}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Role deletion failed" };
  }
};

// Role Update
export const updateRole = async (
  id: number,
  roleData: FormData
): Promise<RoleApiResponse> => {
  try {
    const response = await axiosInstance.post<RoleApiResponse>(
      `/roles/${id}`,
      roleData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Role update failed";
  }
};

export const fetchRoleDropdownList = async (): Promise<RoleDropDown[]> => {
  const response = await axiosInstance.get("/roles-list");
  const data = response.data;

  if (data.status) {
    // Convert `key` to `id` so your dropdown uses `project.id`
    return data.data.map((roles: any) => ({
      id: roles.key,
      name: roles.name,
    }));
  } else {
    throw new Error(data.message || "Failed to fetch roles list");
  }
};
